<template>
	<div class="marketing-section bg-color-greige">
		<div class="container">
			<InfoCardSingular :card="ourPlatformCard" :position-text-right="false" theme="greige" />
		</div>
	</div>
</template>
<script setup lang="ts">
import { InfoCard } from 'types/layout';
import InfoCardSingular from '@components/layout/info-card-singular.vue';

const ourPlatformCard: InfoCard = {
	heading: 'our platform',
	title: 'Your first investment is just the beginning.',
	description: [
		'In less than 5 minutes, you can create an account, choose your portfolio strategy, and complete your first investment.',
		"After you place your initial investment, we'll keep working to add new assets to your portfolio over time — with no additional investment required on your end. This means your already-diversified portfolio can become stronger year after year. You can then continue making contributions manually or set up recurring investments."
	],
	link: {
		text: 'Learn more about our platform',
		router: 'blog-post',
		params: { blogPostUrlSlug: 'what-makes-fundrises-platform-unique' }
	},
	imageUrl: '/images/marketing-site/how-it-works/fundrise-investment-portfolio-asset-breakdown.png'
};
</script>
